import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { SelectItem } from 'primeng/components/common/api';
import { GenericComponent } from './generic-component';
import { GenericService } from '../../../_services/generic-service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Utils } from '../../../utils';

@Component({
    selector: "crud-table",
    templateUrl: './crud-table.component.html',
    inputs: ["title", "keyToadd", "subtitle", "menu", "submenu", "portletTitle", "sortField", "rows", "paginator", "rowsPerPageOptions", "arrTable", "cols", "columnOptions", "item", "itemName", "genericform", "displayDialogAddEdit", "loading"],
    providers: [GenericService]
})


export class CrudTableComponent extends GenericComponent {

    title: string = "";
    subtitle: string = "";
    menu: string = "";
    submenu: string = "";
    sortField: string = "";
    rows: number = 10;
    paginator: boolean;
    rowsPerPageOptions: number[] = [5, 10, 20, 50, 100];
    responsive: boolean = true;
    pageLinks: number = 3;
    cols: any[] = [];
    columnOptions: SelectItem[];
    item: any;
    itemName: string;
    keyToadd: any[] = [];
    constructor(private genericService: GenericService) {
        super(genericService);
        Utils.log("constructor");



    }
    setColumnOttions() {

        this.columnOptions = [];
        for (let i = 0; i < this.cols.length; i++) {
            this.columnOptions.push({ label: this.cols[i].header, value: this.cols[i] });
        }
    }
    /*clone(obj){
        return JSON.parse(JSON.stringify(obj));
    }
    showDialogAdd() {        
        this.arrTable = [];
        let fo = this.clone(this.genericform.value);
        this.cleanForm();
        Utils.log('fo',fo);
        for(let f in fo){
            Utils.log(f);
            if(f.indexOf('id')!= -1 && f != 'id'){
                //this.genericform.value[f] = fo[f];
                Utils.log('f=',f);
                Utils.log('f=',fo[f]);
                this.keyofadd[f] = fo[f];
            }
        }
        
        this.displayDialogAddEdit = true;
    }

    sendToServer(name: string) {
        Utils.log('sssss',this.keyofadd);
        Utils.log(this.genericform.value);
        for(let f in this.keyofadd){
            this.genericform.value[f] = this.keyofadd[f];
        }
        
        
        Utils.log(name);
        Utils.log('--------------',this.genericform.value);
        this.sendToServerObject(name, this.genericform.value);
    }*/

    sendToServer(name: string) {

        this.keyToadd.forEach(element => {
            this.genericform.value[element.key] = element.value;
        });
        this.sendToServerObject(name, this.genericform.value);
    }




}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/crud-table.component.ts